import { Provider } from '@angular/core';

import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

import { ESportLiveButtonService } from './esports-live-button.service';
import { EsportsRefreshRegistrationService } from './esports-refresh-registration.service';

export function provideEsports(): Provider[] {
    return [
        runOnSportsWebInit(EsportsRefreshRegistrationService),
        {
            provide: WidgetLayoutHook,
            useClass: ESportLiveButtonService,
            multi: true,
        },
    ];
}
